import { render, staticRenderFns } from "./RosterGroupFilters.vue?vue&type=template&id=bef47694&"
import script from "./RosterGroupFilters.vue?vue&type=script&lang=js&"
export * from "./RosterGroupFilters.vue?vue&type=script&lang=js&"
import style0 from "./RosterGroupFilters.vue?vue&type=style&index=0&id=bef47694&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports